import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40ed6948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar flex-CN" }
const _hoisted_2 = {
  class: "step-box flex-RN",
  "data-view": "no"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 1}),
        "data-view": "/UploadView"
      }, "校验身份信息", 2),
      _createElementVNode("div", {
        class: _normalizeClass({'active':_ctx.viewIndex === 2}),
        "data-view": "/BankView"
      }, "绑定账号", 2)
    ])
  ]))
}